import { useState, useEffect } from "react";
import debounce from "lodash.debounce";
import { useFetch } from "../../../common/hooks/useFetch";
import { listAuditLogService } from "../services/listAuditLog.service";

const PAGE_SIZE = 25;

export const useAuditLogQuery = (filters) => {
  const fetchData = useFetch();
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        setLoading(true);
        const response = await listAuditLogService(fetchData)({
          ...filters,
          page,
          limit: PAGE_SIZE,
        });
        setLogs(response.data || []);
        setTotal(response.total || 0);
        setTotalPages(response.totalPages || 0);
      } catch (error) {
        console.error(error);
        setLogs([]);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchLogs, 400);
    debouncedFetch();
    return () => debouncedFetch.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters, page]);

  return {
    logs,
    loading,
    total,
    totalPages,
    page,
    onChangePage: (newPage) => setPage(newPage),
    refresh: () => setRefresh((prev) => !prev),
  };
};
